import { Table } from "antd";
import React, { useEffect } from "react";
import moment from "moment";
import { formatCurrency } from "Utils";

export default function CashFlow({ cashFlow, loading, ...props }) {
  const columns = [
    {
      title: "Koşul Amacı",
      width: 200,
      dataIndex: ["purpose", "description"],
      sorter: (a, b) => a.purpose.description - b.purpose.description,
    },
    {
      title: "Koşul Tipi",
      width: 200,
      dataIndex: ["type", "description"],
      sorter: (a, b) => a.type.description - b.type.description,
    },
    {
      title: "Yıl",
      render: (text, record, index) => {
        return moment(record.dateOfMaturity).format("YYYY");
      },
      sorter: (a, b) =>
        parseInt(moment(a.dateOfMaturity).format("YYYY")) -
        parseInt(moment(b.dateOfMaturity).format("YYYY")),
    },
    {
      title: "Dönem",
      render: (text, record, index) => {
        return moment(record.dateOfMaturity).format("MM");
      },
    },
    {
      title: "Vade Tarihi",
      dataIndex: ["dateOfBeginning"],
      render: (text, record, index) => {
        return moment(record.dateOfMaturity).format("DD.MM.YYYY");
      },
    },
    {
      title: "Başlangıç Tarihi",
      dataIndex: ["dateOfBeginning"],
      render: (text, record, index) => {
        return moment(record.dateOfBeginning).format("DD.MM.YYYY");
      },
    },
    {
      title: "Bitiş Tarihi",
      dataIndex: ["dateOfFinish"],
      render: (text, record, index) => {
        return moment(record.dateOfFinish).format("DD.MM.YYYY");
      },
    },
    {
      title: "Tutar",
      dataIndex: "documentAmount",
      width: 100,
      render: (text, record, index) => {
        return formatCurrency(record.documentAmount, record.documentCurrency);
      },
    },
  ];

  return (
    <Table
      size="small"
      scroll={{ x: 1000 }}
      loading={loading}
      bordered
      rowKey={(row) => row.id}
      dataSource={(cashFlow || []).sort((previous, current) => {
        if (
          moment(previous.dateOfMaturity).isBefore(
            moment(current.dateOfMaturity)
          )
        ) {
          return -1;
        }
        if (
          moment(previous.dateOfMaturity).isSame(moment(current.dateOfMaturity))
        ) {
          return 0;
        }
        return 1;
      })}
      columns={columns}
      pagination={false}
    />
  );
}
